import {make_createActionType} from 'src/helpers'
const createActionType = make_createActionType('DB_WIDGET')

export const TOGGLE_CHAT = createActionType('TOGGLE_CHAT')
export const OPEN_CHAT = createActionType('OPEN_CHAT')
export const RESET_CHAT = createActionType('RESET_CHAT')
export const CLOSE_CHAT = createActionType('CLOSE_CHAT')
export const ADD_NEW_USER_MESSAGE = createActionType('ADD_NEW_USER_MESSAGE')
export const ADD_NEW_RESPONSE_MESSAGE = createActionType('ADD_NEW_RESPONSE_MESSAGE')
export const ADD_COMPONENT_MESSAGE = createActionType('ADD_COMPONENT_MESSAGE')
export const DROP_MESSAGES = createActionType('DROP_MESSAGES')
export const SET_QUICK_BUTTONS = createActionType('SET_QUICK_BUTTONS')
export const SET_MENU = createActionType('SET_MENU')
export const SET_TOC = createActionType('SET_TOC')
export const SET_INPUT_DISABLED = createActionType('SET_INPUT_DISABLED')
export const SET_BLINK = createActionType('SET_BLINK')
export const SET_BLINK_COLOR = createActionType('SET_BLINK_COLOR')
export const SET_INPUT_DROPDOWNTYPE = createActionType('SET_INPUT_DROPDOWNTYPE')
export const SET_INPUT_DROPDOWN_OPTIONS = createActionType('SET_INPUT_DROPDOWN_OPTIONS')
export const SET_INPUT_DATETYPE = createActionType('SET_INPUT_DATETYPE')
export const SET_IS_FETCHING = createActionType('SET_IS_FETCHING')
export const SET_THEME = createActionType('SET_THEME')
export const CLEAR_INPUT = createActionType('CLEAR_INPUT')
export const ADD_CAROUSEL = createActionType('ADD_CAROUSEL')
export const SET_STYLES = createActionType('SET_STYLES')
export const SET_SENDER_PLACEHOLDER = createActionType('SET_SENDER_PLACEHOLDER')
export const TOGGLE_TOC = createActionType('TOGGLE_TOC')



// WEBPACK FOOTER //
// ./src/ChatWidget/store/actions/actionTypes.js